/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon20Light = forwardRef('SendPaperplaneIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.889 3.88c-.215-1.106.93-1.977 1.938-1.475l12.811 6.38c1.004.5 1.004 1.93 0 2.43l-12.81 6.38c-1.008.502-2.154-.37-1.94-1.474L4.079 10l-1.19-6.12Zm2.11 6.62L3.87 16.31a.358.358 0 0 0 .512.39l12.81-6.38a.358.358 0 0 0 0-.642L4.382 3.3a.358.358 0 0 0-.512.39L5 9.499h4.72a.5.5 0 1 1 0 1H5Z" })));
});
